import { useGetProfilePermissions } from "@/features/master-data/user/hooks/use-get-profile.hook";
import { TPermissionKey } from "@agt/contract";

export const useHasPermission = (permission: TPermissionKey) => {
  const permissions = useGetProfilePermissions();

  if (permissions[permission]) {
    return true;
  }

  return false;
};
